import * as THREE from 'three';
import { WorkshopArt } from '../art/workshop';
export interface PrototypeSceneHandles { scene: THREE.Scene; dispose: () => void }

export function createPrototypeScene(labels={warehouse:"ALGOQUEST • PARCEL WORKS",receiving:"RECEIVING 01",dispatch:"DISPATCH 02"}): PrototypeSceneHandles {
  const scene = new THREE.Scene();
  scene.background = new THREE.Color(0x9edbf3);
  scene.fog = new THREE.Fog(0x9edbf3, 27, 65);
  scene.add(new THREE.HemisphereLight(0xc8eaff, 0x9b7255, 1.65));
  const sun = new THREE.DirectionalLight(0xffe0ad, 2.5); sun.position.set(-8,14,9); sun.castShadow = true;
  sun.shadow.mapSize.set(2048,2048); Object.assign(sun.shadow.camera, {left:-16,right:16,top:12,bottom:-12}); sun.shadow.normalBias = .035;
  sun.shadow.radius=3;
  scene.add(sun);
  const rim=new THREE.DirectionalLight(0xa1dfff,1.1);rim.position.set(7,6,-4);scene.add(rim);
  const art = new WorkshopArt();
  art.box(scene,0x596879,[34,.55,19],[0,-.42,-2]);
  // Warm tiled loading yard, with genuine seams and a raised grassy border.
  for(let x=-15;x<=15;x+=1.5) for(let z=-10;z<=6;z+=1.5)
    art.box(scene, (Math.round(x+z)*7)%3===0?0xc6b3a0:0xd2c1ad,[1.47,.12,1.47],[x,-.09,z]);
  art.box(scene,0x547d53,[34,.2,5],[0,-.08,-13]);
  // Warehouse facade, timber framing, loading doors and clerestory windows.
  art.box(scene,0xe8b77a,[23,7,.6],[0,3.4,-7]);
  art.box(scene,0x344964,[24,.45,1.6],[0,7,-6.8]);
  for(const x of [-10,-5,0,5,10]) {
    art.box(scene,0x8b5739,[.25,7,.8],[x,3.4,-6.65]);
    art.box(scene,0x45617b,[3.5,2.9,.12],[x,1.55,-6.62]);
    for(let y=.3;y<3;y+=.34) art.box(scene,0x668197,[3.4,.045,.08],[x,y,-6.51]);
    art.box(scene,0x243b55,[3.5,1.65,.15],[x,4.65,-6.55]);
    for(const dx of [-.85,.85]) {
      art.box(scene,0x9cd8e5,[1.5,1.36,.08],[x+dx,4.65,-6.45]);
      art.box(scene,0xf5dbaa,[.06,1.4,.12],[x+dx,4.65,-6.35]);
    }
  }
  art.box(scene,0x805337,[5.7,1,.22],[0,6.35,-6.33]);
  art.label(scene,labels.warehouse,5.3,.7,[0,6.35,-6.2]);
  // Loaded shelving at both sides leaves the puzzle silhouette unobstructed.
  for(const side of [-1,1]) {
    const x=side*9;
    for(const dx of [-1.4,1.4]) art.box(scene,0x30465e,[.13,4.6,.14],[x+dx,2.25,-3.7]);
    for(const y of [.2,1.65,3.1,4.55]) {
      art.box(scene,0x42576a,[3.1,.14,1.6],[x,y,-3.7]);
      if(y<4) for(const dx of [-.88,.3]) art.crate(scene,x+dx,y+.07,-3.65,.85);
    }
    for(let i=0;i<3;i++) art.crate(scene,side*(6.8+i*.95),0,3.6,i===1?1.1:.8);
    art.box(scene,0xe3a12d,[.2,1.6,.2],[side*6.8,.8,-4]);
    art.sphere(scene,0xffdf78,.23,[side*6.8,1.7,-4]);
    for(let i=0;i<3;i++) {
      const tx=side*(13+i*1.3),tz=-7-i*2;
      art.box(scene,0x926043,[.4,3,.4],[tx,1.4,tz]);
      art.sphere(scene,0x639445,1.9,[tx,4,tz]); art.sphere(scene,0x91b949,1.35,[tx-.6,5,tz]);
    }
  }
  // Small forklift parked behind the action lane.
  const fork = new THREE.Group(); fork.position.set(-5,0,-4.1); scene.add(fork);
  art.box(fork,0xeeb52d,[1.3,.6,1.7],[0,.65,0]);
  for(const x of [-.65,.65]) for(const z of [-.52,.52]) art.sphere(fork,0x263343,.3,[x,.32,z]);
  for(const x of [-.55,.55]) art.box(fork,0x273b50,[.1,1.65,.1],[x,1.7,-.2]);
  art.box(fork,0xfbc749,[1.45,.15,1.3],[0,2.55,-.2]);
  for(const x of [-.4,.4]) { art.box(fork,0x354559,[.1,2.1,.12],[x,1.1,1]); art.box(fork,0x566479,[.17,.08,1.1],[x,.16,1.45]); }
  // Painted loading lane, safety bollards and layered facade details.
  for(const side of [-1,1]){
    for(let z=-2;z<=4;z+=1.2)art.box(scene,0xf5d286,[.1,.012,.7],[side*5.9,.005,z]);
    art.box(scene,0x345568,[2.2,.85,.15],[side*5,3.6,-6.2]);
    art.label(scene,side<0?labels.receiving:labels.dispatch,1.95,.55,[side*5,3.6,-6.1],'#24465a','#ffe6ac');
    for(const x of [side*7,side*11]){
      art.box(scene,0x344c60,[.32,.13,.32],[x,.065,-5.2]);
      art.box(scene,0xefb442,[.19,.9,.19],[x,.55,-5.2]);
      art.box(scene,0x344c60,[.2,.16,.2],[x,.65,-5.2]);
    }
  }
  art.box(scene,0x39586a,[3.4,.12,1.15],[0,3.8,-6.15]);
  for(let x=-1.5;x<=1.5;x+=.5)art.box(scene,0xf5d697,[.25,.12,1.17],[x,3.81,-6.14]);
  art.batchStatic(scene);
  return { scene, dispose: () => { art.dispose(); sun.shadow.dispose(); scene.clear(); } };
}
